<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card color="#FFD375" class="elevation-12">
        <v-toolbar color="#FFA500">
            <v-toolbar-title>{{title}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field class="mt-6" name="name" label="Name" v-model="name" :rules="nameRules" required></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#FFA500" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
     value: Boolean,
     selectedgroup: Object
  },
  data() {
      return {
          valid: false,
          group: this.selectedgroup,
          name: "",
          email: "",
          modal: false,
          nameRules: [
              v => !!v || 'Name is required',
          ]
      };
  },
  computed: {
    show: {
      get () {
            this.group = this.selectedgroup;
            this.initialiseData();
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    },
    title(){
        if (!this.group)
            return "New Group";
        else 
            return "Edit Group";
    }
    
  },
  methods: {
      initialiseData(){
          if (!this.selectedgroup)
              {
              this.name="";
              }
          else {
              this.name=this.selectedgroup.Name;
          }
      },
      cancel(){
          this.name='';
          this.show=false;
      },
      submit() {
        var xn=this.name;
        var g=0;
          if (this.$refs.form.validate()) {
              if (!this.selectedgroup)
                  this.group={};
              this.group.Name=this.name;
              if (!this.selectedgroup){
                  this.$store.dispatch('addGroup', this.group);
              }
              else {
                  this.$store.dispatch('setGroup', this.group);
              }
              this.name='';
              this.show=false;
          }
      }
  }
}
</script>